import request from '@/utils/request' 

//添加权限
export const addUser = (params) => {
    return request({
      url: '/api/users/add', 
      method: 'POST',
      data: params 
    })
  }

  //获取权限列表
  export const getUserList = (data) => {
    return request({
      url: '/api/users/list',
      method: 'GET',
      params:data
    })
  }
  
  //删除权限
export const deleteUser = (params) => {
    return request({
      url: '/api/users/delete', 
      method: 'POST',
      data: params 
    })
  }

  //编辑权限
  export const editUser = (params) => {
    return request({
      url: '/api/users/update', 
      method: 'POST',
      data: params 
    })
  }
  
 //获取当前登录用户信息
 export const getUserinfo = (data) => {
  return request({
    url: '/api/auth/me',
    method: 'GET',
    params:data
  })
}